import React from "react";

import { css } from "@emotion/css";
import { desktop, laptop, mobile, tablet } from "../../../styles/breakpoints";

import ICON11 from "../../../img/svg/home/about/_29.svg";
import ICON12 from "../../../img/svg/home/about/_16.svg";
import ICON21 from "../../../img/svg/home/about/_7.svg";
import ICON22 from "../../../img/svg/home/about/_3.svg";
import ICON31 from "../../../img/svg/home/about/_21.svg";
import ICON32 from "../../../img/svg/home/about/_14.svg";
import ICON41 from "../../../img/svg/home/about/_44.svg";
import ICON42 from "../../../img/svg/home/about/_15.svg";
import ICON51 from "../../../img/svg/home/about/_23.svg";
import ICON52 from "../../../img/svg/home/about/_33.svg";
import BG from "../../../img/svg/home/about/bg.svg";
import ICONSUN from "../../../img/svg/home/about/sun.svg";
import { useI18n } from "../../../i18n";

const Features = () => {
  const { t } = useI18n();
  return (
    <div className={style.main}style={{ position: "relative", background: "#000"}}>
      <div className={style.bg}>
        <span></span>
      </div>

      <div className={style.container}>
        <div className="heading">
          <h3>{t("home_features_giving")}</h3>
          <img src={ICONSUN} className={`icon-sun`} alt="" />
          <h2>{t("home_features_deja_vu")}</h2>
        </div>

        <div className="wrapper">
          <div className={`item i1`}>
            <div className="icon-wrapper">
              <img src={ICON51} alt="" height={50} />
              <img src={ICON52} alt="" height={50} />
            </div>
            <h5>{t("home_features_identity")}<br />{t("home_features_crisis")}</h5>
            <p>
                {t("home_features_identity_body")}
            </p>
          </div>
          <div className={`item i2`}>
            <div className="icon-wrapper">
              <img src={ICON11} alt="" height={50} />
              <img src={ICON12} alt="" height={50} />
            </div>
            <h5>{t("home_features_overflow")}</h5>
            <p>
              {t("home_features_overflow_body")}
            </p>
          </div>
          <div className={`item i3`}>
            <div className="icon-wrapper">
              <img src={ICON21} alt="" height={50} />
              <img src={ICON22} alt="" height={50} />
            </div>
            <h5>{t("home_features_favourites")}</h5>
            <p>
            {t("home_features_favourites_body")}
            </p>
          </div>
          <div className={`item i4`}>
            <div className="icon-wrapper">
              <img src={ICON31} alt="" height={50} />
              <img src={ICON32} alt="" height={50} />
            </div>
            <h5>{t("home_features_wanted")}</h5>
            <p>
              {t("home_features_wanted_body")}
            </p>
          </div>
          <div className={`item i5`}>
            <div className="icon-wrapper">
              <img src={ICON41} alt="" height={50} />
              <img src={ICON42} alt="" height={50} />
            </div>
            <h5>{t("home_features_sizing")}</h5>
            <p>
              {t("home_features_sizing_body")}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

const style = {
  main: css({
    marginTop: -100,

    [laptop]: {
    marginTop: 0,
    },
  }),

  bg: css({
    backgroundRepeat: "no-repeat",
    backgroundPosition: "top center",
    backgroundSize: "cover",
    backgroundImage: `url(${BG})`,
    width: "100%",
    height: 700,
    position: "absolute",
    top: 100,

    [desktop]: {
      height: 500,
    },

    [laptop]: {
      top: 60,
      height: 450,
    },
    [tablet]: {
      height: 350,
      top: 20,
    },
  }),

  container: css({
    height: "100%",
    display: "flex",
    flexDirection: "column",
    alignContent: "flex-start",
    flexWrap: "nowrap",
    justifyContent: "flex-start",
    alignItems: "center",
    maxWidth: 1172,
    margin: "auto",
    padding: 40,
    backgroundColor: "#000000",
    paddingTop: 80,
    marginBottom: 100,
    zIndex: 1,

    h3: {
      color: "#FFF",
      textAlign: "center",
      fontFamily: "Syne",
      fontSize: 74.864,
      fontStyle: "normal",
      fontWeight: 700,
      lineHeight: "74.554px",
      marginBottom: 25,
      zIndex: 1,
    },
    h2: {
      color: "#FFF",
      textAlign: "center",
      fontFamily: "Syne",
      fontSize: 123.375,
      fontStyle: "normal",
      fontWeight: 800,
      lineHeight: "122.863px",
      textTransform: "uppercase",
      marginBottom: 210,
      zIndex: 1,
    },

    ".heading": {
      display: "flex",
      flexDirection: "column",
      alignContent: "flex-start",
      flexWrap: "nowrap",
      justifyContent: "flex-start",
      alignItems: "center",
      position: "relative",

      ".icon-sun": {
        position: "absolute",
        zIndex: 0,
        right: 160,
        top: 20,
        width: 155,
        height: 155,
      },
    },
    ".wrapper": {
      display: "flex",
      flexDirection: "row",
      flexWrap: "wrap",
      alignContent: "center",
      justifyContent: "center",
      alignItems: "center",
      gap: 10,

      ".item": {
        position: "relative",
        borderRadius: 100,
        border: "2px solid rgba(118, 0, 255, 0.50)",
        background: "#000",
        justifyContent: "flex-start",
        alignItems: "flex-start",
        alignSelf: "stretch",
        display: "flex",
        flexDirection: "column",
        flexWrap: "nowrap",
        alignContent: "center",
        width: 290,
        padding: "0 43px",
        paddingTop: 50,
        paddingBottom: 50,

        img: {
          marginBottom: 30,
        },
        h5: {
          color: "#FFF",
          fontFamily: "Syne",
          fontSize: 27,
          fontStyle: "normal",
          fontWeight: 600,
          lineHeight: "normal",
          marginBottom: 15,
        },
        p: {
          color: "#FFF",
          fontFamily: "Inter",
          fontSize: 13,
          fontStyle: "normal",
          fontWeight: 400,
          lineHeight: "normal",
          letterSpacing: 0.13,
        },

        ".icon-wrapper": {
          gap: 16,
          display: "flex",
          flexDirection: "row",
          flexWrap: "nowrap",
          justifyContent: "flex-start",
          alignItems: "center",

          img: {
            width: "100%",
          },
        },
      },

      ".i4, .i5": {
        width: "330px !important",
        paddingLeft: 70,
        paddingRight: 70
      },
    },
    [desktop]: {
      maxWidth: 800,
      marginTop: '-150px',
      marginBottom: 80,

      h3: {
        fontSize: 60,
        fontStyle: "normal",
        fontWeight: 700,
        lineHeight: "59.458px",
      },
      h2: {
        fontSize: 96,
        fontStyle: "normal",
        fontWeight: 800,
        lineHeight: "97.985px",
        textTransform: "uppercase",
        marginBottom: 140,
      },
      ".heading": {
        ".icon-sun": {
          right: 100,
          top: -5,
        },
      },
      ".wrapper": {
        gap: 15,

        ".item": {
          borderRadius: 85,
          gap: 0,
          img: {
            marginBottom: 20,
            height: 45
          },
          h5: {
            fontSize: 24,
            marginBottom: 15,
          },
          p: {
            fontSize: 14,
          },
        },
        ".i1, .i2, .i3, .i4": {
          width: "280px !important",
          height: "280px !important",
          padding: 33,
        },
        ".i5": {
          width: "280px !important",
          paddingTop: 33,
          paddingBottom: 33,
        },
      },
    },
    [laptop]: {
      marginTop: 0,
      marginBottom: 60,
      h3: {
        fontSize: 39.564,
        fontStyle: "normal",
        fontWeight: 700,
        lineHeight: "37.875px",
        marginBottom: 15,
      },
      h2: {
        fontSize: 63.911,
        fontStyle: "normal",
        fontWeight: 800,
        lineHeight: "62.418px",
        marginBottom: 40,
      },
      img: {
        marginBottom: 10,
      },
      ".heading": {
        ".icon-sun": {
          right: 75,
          top: -5,
          width: 100,
          height: 100,
        },
      },
      ".wrapper": {
        gap: 15,

        ".item": {
          h5: {
            fontSize: 22,
            marginBottom: 15,
          },
          p: {
            fontSize: 14,
          },
        },
        ".i1, .i2, .i3, .i4": {
          width: "255px !important",
          height: "255px !important",
          padding: 33,
        },
        ".i5": {
          width: "320px !important",
        },
      },
      [tablet]: {

        h3: {
          fontSize: 26,
          fontStyle: 'normal',
          fontWeight: 700,
          lineHeight: '24.891px',
          marginBottom: 10,
        },
        h2: {
          fontSize: 42,
          fontStyle: "normal",
          fontWeight: 800,
          lineHeight: "41px",
          marginBottom: 50,
        },
        img: {
          marginBottom: 10,
        },
        ".heading": {
          ".icon-sun": {
            right: 45,
            top: -5,
            width: 60,
            height: 60,
          },
        },
        ".wrapper": {
          gap: 15,

          ".item": {
            h5: {
              fontSize: 20,
              marginBottom: 15,
            },
            p: {
              fontSize: 12,
            },
          },
          ".i1, .i2, .i3, .i4, .i5": {
            width: "260px !important",
            paddingLeft: 34,
            paddingRight: 34,

            h5: {
              maxWidth: 250
            },
          },
      },
    },
      [mobile]: {},
    },
  }),
};

export default Features;
